import { Box, Stack, Typography } from '@mui/material';

type BrandStatsCardProps = {
    brand: {
        brandPhotos?: Array<{ _id: string }>;
        brandVideos?: Array<{ _id: string }>;
    };
};

const BrandStatsCard = ({ brand }: BrandStatsCardProps) => {
    return (
        <Box
            sx={{
                p: 3,
                borderRadius: '16px',
                bgcolor: 'dashboard.main',
            }}
        >
            <Typography variant="body2" fontWeight={700} color="neutralWhite.main" mb={2}>
                Médias
            </Typography>
            <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={1}>
                        <i className="fi fi-br-images" style={{ fontSize: 14, opacity: 0.7 }} />
                        <Typography variant="body2" color="textSecondary">Photos</Typography>
                    </Stack>
                    <Typography variant="body2" fontWeight={700} color="neutralWhite.main">
                        {brand.brandPhotos?.length ?? 0}
                    </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={1}>
                        <i className="fi fi-br-play-alt" style={{ fontSize: 14, opacity: 0.7 }} />
                        <Typography variant="body2" color="textSecondary">Vidéos</Typography>
                    </Stack>
                    <Typography variant="body2" fontWeight={700} color="neutralWhite.main">
                        {brand.brandVideos?.length ?? 0}
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BrandStatsCard;
